function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Flex, Box } from "../Box";
// import { Link } from "../Link";
import { StyledFooter, StyledIconMobileContainer, // StyledList,
// StyledListItem,
// StyledText,
StyledTextDisclaimer, StyledTextDisclaimerContent, StyledSocialLinks, StyledToolsContainer } from "./styles";
import CakePrice from "../CakePrice/CakePrice";
import { LogoWithTextIcon } from "../Svg";
import { Button } from "../Button";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, buyBNBComponent = _param.buyBNBComponent, props = _objectWithoutProperties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel",
        "buyBNBComponent"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _objectSpread({
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props, {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                        isDark: true,
                        width: "130px"
                    })
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: [
                        "42px",
                        null,
                        "36px"
                    ],
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "block"
                            ],
                            children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                                isDark: true,
                                width: "160px"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "block"
                            ],
                            mt: [
                                "30px",
                                null,
                                "30px"
                            ],
                            mb: [
                                "8px"
                            ],
                            children: /*#__PURE__*/ _jsx(StyledTextDisclaimer, {
                                children: "Disclaimer:"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "block"
                            ],
                            children: /*#__PURE__*/ _jsx(StyledTextDisclaimerContent, {
                                children: "Trading crypto assets has high opportunities and risks. Make sure you use good judgment in making buying and selling decisions on your assets. SCOL COIN Swap does not force users to make buying and selling transactions and all buying and selling decisions of your digital money assets are your own decisions and are not influenced by any party."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledSocialLinks, {
                    order: [
                        2
                    ],
                    pb: [
                        "42px",
                        null,
                        "32px"
                    ],
                    mb: [
                        "0",
                        null,
                        "32px"
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledToolsContainer, {
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        order: [
                            1,
                            null,
                            2
                        ],
                        mb: [
                            "24px",
                            null,
                            "0"
                        ],
                        justifyContent: "flex-end",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                mr: "20px",
                                children: /*#__PURE__*/ _jsx(CakePrice, {
                                    cakePriceUsd: cakePriceUsd,
                                    color: "contrast"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                as: "a",
                                href: "/swap",
                                target: "_blank",
                                scale: "sm",
                                // endIcon={<ArrowForwardIcon color={lightColors.backgroundAlt} />}
                                style: {
                                    color: "#FFFFFF"
                                },
                                children: buyCakeLabel
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
export default MenuItem;
